import React, { useState } from "react";

import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import PartsListWithCheckbox from "@/main/components/shared/partsListWithCheckbox/partsListWithCheckbox";

import { GetItemsByStatusResponse } from "@/main/models/response";
import { getTranslateByKey } from "@/main/services/utils";
import * as S from "./styles";
import ChangeStatusFileUpload from "./changeStatusFileUpload";

interface IChangeStatus {
  confirmMessage: string;
  closeModal: () => void;
  options: GetItemsByStatusResponse[];
  optionsSelected: string[];
  setOptionsSelected: React.Dispatch<React.SetStateAction<string[]>>;
  files: File[];
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
  handleSubmitChangeStatus(): void;
  loadingSubmit: boolean;
  loadingOptions: boolean;
}

function ChangeStatus({
  confirmMessage,
  closeModal,
  options,
  optionsSelected,
  setOptionsSelected,
  files,
  setFiles,
  handleSubmitChangeStatus,
  loadingSubmit,
  loadingOptions
}: IChangeStatus) {
  function handleSubmit() {
    handleSubmitChangeStatus()
  }

  return (
    <>
      <S.Content>
        <PartsListWithCheckbox
          parts={options}
          optionsSelected={optionsSelected}
          setOptionsSelected={setOptionsSelected}
          isLoading={loadingOptions}
        />
      </S.Content>

      <ChangeStatusFileUpload
        files={files}
        setFiles={setFiles}
      />

      <S.ContainerButton>
        <SecondaryButton onClick={closeModal}>
          {getTranslateByKey('information.back')}
        </SecondaryButton>
        <SecondaryButton
          onClick={handleSubmit}
          disabled={optionsSelected.length == 0 || loadingSubmit}
          isLoading={loadingSubmit}
        >
          {confirmMessage}
        </SecondaryButton>
      </S.ContainerButton>
    </>
  )
}

export default ChangeStatus;